var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"property-media-preview-bridge",staticStyle:{"display":"none"},attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }